import { memo } from 'react';
import { cn, Price } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import getProductName from '@Utils/getProductName';
import Link from '@Navigation/Link';
import ProductImage from '@Components/ProductImage';
import styles from './ProductCard.module.css';

import type { CartPositionData } from '@Types/Cart';
import type { HTMLAttributes, FC } from 'react';

interface ProductCardProps extends HTMLAttributes<HTMLDivElement> {
  position: CartPositionData;
}

const ProductCard: FC<ProductCardProps> = (props) => {
  const { position, ...restProps } = props;
  const product = position.products[0];
  const hasExpired = product.oldprice > 0 && product.oldprice !== product.price;
  const { t } = useTranslation();

  return (
    <div {...restProps}>
      <Link to={product.link} target='_blank'>
        <ProductImage
          className={cn(styles.image, { [styles.portrait]: product.orientation === 'portrait' })}
          src={product.image}
        />
      </Link>
      <div className={styles.containerInfo}>
        <div className={styles.info}>
          <div className={styles.name}>{getProductName(product)}</div>
          <div className={styles.price}>
            <Price className={styles.actualPrice} price={product.price} />
            &nbsp;
            {hasExpired && (
              <Price expired className={styles.expiredPrice} price={product.oldprice} />
            )}
          </div>
        </div>
      </div>
      <div className={styles.productCount}>
        <span className={styles.countText}>{t('ui.cart.amount')}</span>
        <span className={styles.points} />
        <span>
          {position.quantity} {t('ui.items')}
        </span>
      </div>
    </div>
  );
};

export default memo(ProductCard);
